import { useAtomValue } from 'jotai';

import type { LeadsFacets, LeadsTableRow,PaginatedResponse } from '@ekhodealer/ekho-common';

import { useSearchLeads } from '../api/useSearchLeads';
import { leadsBaseParamsAtom } from '../atoms/leadsAtoms';
import { computePreQualStatusCounts } from '../utils/utils';

/**
 * Hook to get facet counts for filter options
 * Returns counts for stage, type, models, dealers, and prequalified filters
 * Uses base params (without most filters) to show total available options
 *
 * Facets are transformed in the backend and returned in a UI-friendly structure.
 */
export function useLeadsFacetCounts() {
	const baseParams = useAtomValue(leadsBaseParamsAtom);
	const { data } = useSearchLeads(baseParams);

	const response = data as PaginatedResponse<LeadsTableRow> | undefined;
	const facets = response?.facets as LeadsFacets | undefined;

	return {
		stageCounts: facets?.stage || {},
		typeCounts: facets?.type || {},
		modelCounts: facets?.models || {},
		accountCounts: facets?.svpId || {},
		preQualStatusCounts: computePreQualStatusCounts(
			facets?.preQualStatus,
			response?.count ?? 0,
		),
		pipelineCounts: facets?.pipelineCounts || ({} as Partial<Record<string, number>>),
	};
}
